// Import layouts
import MainLayout from '../Layout/MainLayout';
import AuthLayout from '../AuthLayout/AuthLayout';

// Import pages
import Dashboard from '../Pages/Dashboard';
import Login from '../Pages/Auth/Login';
import ChangePassword from '../Pages/ChangePassword';
import UserList from '../Pages/User/UserList';
import UserAdd from '../Pages/User/UserAdd';
import UserEdit from '../Pages/User/UserEdit';
import UserView from '../Pages/User/UserView';
import QuotationList from '../Pages/Quotation/QuotationList';
import QuotationAdd from '../Pages/Quotation/QuotationAdd';
import QuotationEdit from '../Pages/Quotation/QuotationEdit';
import QuotationView from '../Pages/Quotation/QuotationView';
import EstimateList from '../Pages/Estimate/EstimateList';
import EstimateAdd from '../Pages/Estimate/EstimateAdd';
import EstimateEdit from '../Pages/Estimate/EstimateEdit';
import EstimateView from '../Pages/Estimate/EstimateView';
import ContractAdd from '../Pages/Contract/ContractAdd';
import ContractList from '../Pages/Contract/ContractList';
import LeadList from '../Pages/Leads/LeadList';
import ContractUpdate from '../Pages/Contract/ContractUpdate';
import MilestoneList from '../Pages/Milestone/MilestoneList';
import AddMilestone from '../Pages/Milestone/AddMilestone';
import EditMilestone from '../Pages/Milestone/EditMilestone';
import AddProposal from '../Pages/Proposal/AddProposal';
import ProposalList from '../Pages/Proposal/ProposalList';
import EditProposal from '../Pages/Proposal/EditProposal'; // Add this import
import OppertunityList from '../Pages/Opportunities/OpportunityList';
import TechStackAdd from '../Pages/HourlyRate/AddTechStackRate'; // <-- Add this import
import HourlyTechStackList from '../Pages/HourlyRate/HourlyTechStackList';
import EditTechStackRate from '../Pages/HourlyRate/EditTechStackRate';
import Home from '../Pages/Home';
import AddQARate from '../Pages/HourlyRate/AddQARate';
import HourlyQARateList from '../Pages/HourlyRate/HourlyQARateList';
import EditQARate from '../Pages/HourlyRate/EditQARate';
import AddTechstack from '../Pages/TechStack/AddTechstack';
import TechStackList from '../Pages/TechStack/TechStackList';
import EditTechStack from '../Pages/TechStack/EditTechStack';
import Discount from '../Pages/Discount/DiscountAdd';
import DiscountList from '../Pages/Discount/DiscountList';
import DiscountEdit from '../Pages/Discount/DiscountEdit';
import AddOnAdd from '../Pages/AddOn/AddOnAdd';
import AddOnList from '../Pages/AddOn/AddOnList';
import AddOnEdit from '../Pages/AddOn/AddOnEdit';
import AddSEORate from '../Pages/HourlyRate/AddSEORate';
import SEORateList from '../Pages/HourlyRate/SEORateList';
import EditSEORate from '../Pages/HourlyRate/EditSEORate';
// import QuotationClient from "../Pages/Quotation/QuotationClient";
import ServiceProviderList from '../Pages/ServiceProvider/ServiceProviderList';
import ServiceProviderAdd from '../Pages/ServiceProvider/ServiceProviderAdd';
import ServiceProviderEdit from '../Pages/ServiceProvider/ServiceProviderEdit';
import BankList from '../Pages/Bank/BankList';
import BankAdd from '../Pages/Bank/BankAdd';
import BankEdit from '../Pages/Bank/BankEdit';
import ContractTypeList from '../Pages/ContractType/ContractTypeList';
import ContractTypeAdd from '../Pages/ContractType/ContractTypeAdd';
import ContractTypeEdit from '../Pages/ContractType/ContractTypeEdit';
import ContractTypeView from '../Pages/ContractType/ContractTypeView';
import RolePermissions from '../Pages/RolePermission/List';
import AddRole from '../Pages/RolePermission/Add';
import EditRole from '../Pages/RolePermission/Edit';
import ViewRole from '../Pages/RolePermission/View';
// Route configuration
export const routes = [
   {
      layout: AuthLayout,
      isAuthorized: false,
      path: '/*',
      routes: [
         {
            name: 'Login',
            title: 'Login',
            component: Login,
            path: '/login',
         },
      ],
   },
   {
      layout: MainLayout,
      isAuthorized: true,
      path: '/*',
      routes: [
         {
            name: 'Dashboard',
            title: 'Dashboard',
            component: Dashboard,
            path: '/dashboard',
         },
         {
            name: 'ChangePassword',
            title: 'Change Password',
            component: ChangePassword,
            path: '/profile',
         },
         {
            name: 'RolePermissions',
            title: 'Role Permissions',
            component: RolePermissions,
            path: '/role-permissions',
         },
         {
            name: 'AddRole',
            title: 'Add Role',
            component: AddRole,
            path: '/role-add',
         },
         {
            name: 'EditRole',
            title: 'Edit Role',
            component: EditRole,
            path: '/role-edit/:id',
         },
         {
            name: 'ViewRole',
            title: 'View Role',
            component: ViewRole,
            path: '/role-view/:id',
         },
         {
            name: 'UserList',
            title: 'User List',
            component: UserList,
            path: '/user',
         },
         {
            name: 'UserAdd',
            title: 'Add User',
            component: UserAdd,
            path: '/user-add',
         },
         {
            name: 'UserView',
            title: 'View User',
            component: UserView,
            path: '/user/:id',
         },
         {
            name: 'UserEdit',
            title: 'Edit User',
            component: UserEdit,
            path: '/user-edit/:id',
         },
         {
            name: 'QuotationList',
            title: 'Quotation List',
            component: QuotationList,
            path: '/quotation',
         },
         {
            name: 'QuotationAdd',
            title: 'Add Quotation',
            component: QuotationAdd,
            path: '/quotation-add',
         },
         {
            name: 'QuotationEdit',
            title: 'Edit Quotation',
            component: QuotationEdit,
            path: '/quotation-edit/:id',
         },
         {
            name: 'QuotationView',
            title: 'View Quotation',
            component: QuotationView,
            path: '/quotation/:id',
         },
         {
            name: 'DiscountAdd',
            title: 'Add Discount',
            component: Discount,
            path: '/discount-add',
         },
         {
            name: 'DiscountList',
            title: 'Discount List',
            component: DiscountList,
            path: '/discount',
         },
         {
            name: 'DiscountListEdit',
            title: 'Edit Discount',
            component: DiscountEdit,
            path: '/discount-edit/:id',
         },
         {
            name: 'AddOnAdd',
            title: 'Add Service-For-Sell',
            component: AddOnAdd,
            path: '/services-for-sell-add',
         },
         {
            name: 'AddOnList',
            title: 'Service-For-Sell List',
            component: AddOnList,
            path: '/services-for-sell',
         },
         {
            name: 'AddOnEdit',
            title: 'Edit Service-For-Sell',
            component: AddOnEdit,
            path: '/services-for-sell-edit/:id',
         },
         {
            name: 'EstimateList',
            title: 'Estimate List',
            component: EstimateList,
            path: '/estimate',
         },
         {
            name: 'EstimateAdd',
            title: 'Add Estimate',
            component: EstimateAdd,
            path: '/estimate-add',
         },
         {
            name: 'EstimateEdit',
            title: 'Edit Estimate',
            component: EstimateEdit,
            path: '/estimation-edit/:id',
         },
         {
            name: 'EstimateView',
            title: 'View Estimate',
            component: EstimateView,
            path: '/estimation/:id',
         },
         {
            name: 'ContractAdd',
            title: 'Add Contract',
            component: ContractAdd,
            path: '/contract-add',
         },
         {
            name: 'ContractEdit',
            title: 'Edit Contract',
            component: ContractUpdate,
            path: '/contract-edit/:id',
         },
         {
            name: 'ContractList',
            title: 'Contract List',
            component: ContractList,
            path: '/contract',
         },
         {
            name: 'Leads',
            title: 'Leads',
            component: LeadList,
            path: '/leads',
         },
         {
            name: 'Opportunities',
            title: 'Opportunities',
            component: OppertunityList,
            path: '/Opportunities',
         },
         {
            name: 'Milestones',
            title: 'Milestones',
            component: MilestoneList,
            path: '/milestones',
         },
         {
            name: 'MilestoneAdd',
            title: 'Add Milestone',
            component: AddMilestone,
            path: '/milestone-add',
         },
         {
            name: 'MilestoneEdit',
            title: 'Edit Milestone',
            component: EditMilestone,
            path: '/milestone-edit/:id',
         },
         {
            name: 'Proposal',
            title: 'Add Proposal',
            component: AddProposal,
            path: '/proposal-add',
         },
         {
            name: 'ProposalList',
            title: 'Proposal List',
            component: ProposalList,
            path: '/proposal',
         },
         {
            name: 'EditProposal',
            title: 'Edit Proposal',
            component: EditProposal,
            path: '/proposal-edit/:id',
         },
         {
            name: 'TechStackAdd',
            title: 'Add Tech Stack (Hourly Rate)',
            component: TechStackAdd,
            path: '/hourly-rate/tech-stack-add',
         },
         // {
         //    name: 'TechStackHourlyRateList',
         //    title: 'Tech Stack (Hourly Rate List)',
         //    component: HourlyTechStackList,
         //    path: '/hourly-rate/tech-stack',
         // },
         // {
         //    name: 'TechStackHourlyRateEdit',
         //    title: 'Edit Tech Stack (Hourly Rate Edit)',
         //    component: EditTechStackRate,
         //    path: '/hourly-rate/tech-stack-edit/:id',
         // },
         // {
         //    name: 'SERateAdd',
         //    title: 'Add SEO Rate',
         //    component: AddSEORate,
         //    path: '/hourly-rate/add-seo-rate',
         // },
         // {
         //    name: 'SERateList',
         //    title: 'SEO Rate List',
         //    component: SEORateList,
         //    path: '/hourly-rate/seo-rate-list',
         // },
         // {
         //    name: 'SERateEdit',
         //    title: 'Edit SEO Rate',
         //    component: EditSEORate,
         //    path: '/hourly-rate/seo-rate-edit/:id',
         // },
         {
            name: 'Home',
            title: 'Home',
            component: Home,
            path: '/',
         },
         // {
         //    name: 'AddQARate',
         //    title: 'Add QA Rate',
         //    component: AddQARate,
         //    path: '/hourly-rate/add-qa-rate',
         // },
         // {
         //    name: 'HourlyQARateList',
         //    title: 'Hourly QA Rate List',
         //    component: HourlyQARateList,
         //    path: '/hourly-rate/qa-rate-list',
         // },
         // {
         //    name: 'EditQARate',
         //    title: 'Edit QA Rate',
         //    component: EditQARate,
         //    path: '/hourly-rate/qa-rate-edit/:id',
         // },
         {
            name: 'AddTechstack',
            title: 'Add Tech Stack',
            component: AddTechstack,
            path: '/tech-stack/add-techstack',
         },
         {
            name: 'TechStackList',
            title: 'Tech Stack List',
            component: TechStackList,
            path: '/tech-stack/techstacklist',
         },
         {
            name: 'EditTechstack',
            title: 'Edit Tech Stack',
            component: EditTechStack,
            path: '/tech-stack/edit-techstack/:id',
         },
         {
            name: 'ServiceProviderList',
            title: 'List ServiceProvider',
            path: '/service-providers',
            component: ServiceProviderList,
         },
         {
            name: 'ServiceProviderAdd',
            title: 'Add ServiceProvider',
            path: '/service-providers/create',
            component: ServiceProviderAdd,
         },
         {
            name: 'ServiceProviderEdit',
            title: 'Edit ServiceProvider',
            path: '/service-providers/update/:id',
            component: ServiceProviderEdit,
         },
         {
            name: 'BankEdit',
            title: 'Edit Bank',
            path: '/bank',
            component: BankList,
         },
         {
            name: 'BankEdit',
            title: 'Edit Bank',
            path: '/bank/create',
            component: BankAdd,
         },
         {
            name: 'BankEdit',
            title: 'Edit Bank',
            path: '/bank/update/:id',
            component: BankEdit,
         },
         {
            name: 'ContractTypeList',
            title: 'Contract Types',
            path: '/contract-type/list',
            component: ContractTypeList,
         },
         {
            name: 'ContractTypeAdd',
            title: 'Add Contract Type',
            path: '/contract-type/add',
            component: ContractTypeAdd,
         },
         {
            name: 'ContractTypeEdit',
            title: 'Edit Contract Type',
            path: '/contract-type/edit/:id',
            component: ContractTypeEdit,
         },
         {
            name: 'ContractTypeView',
            title: 'View Contract Type',
            path: '/contract-type/view/:id',
            component: ContractTypeView,
         },
      ],
   },
];
